import React from "react"
import { ITextProps } from "../../types/textTypes"
import mapStylesFromProps from "../../utils/mapStylesFromProps"

interface Props extends ITextProps {}

const Body1 = (props: Props) => {
  const className = `font-raleway-light text-xs sm:text-sm md:text-base ${mapStylesFromProps(
    props
  )}`
  return (
    <span className={className} style={props.style}>
      {props.children}
    </span>
  )
}

export default Body1
